import { Module } from 'vuex';
import { TrackingState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { TRACKING_ACTIONS } from './tracking.actions';
import { TRACKING_MUTATIONS } from './tracking.mutations';
import { getInitialTrackingState } from './tracking.state';

export const TRACKING_MODULE: Module<TrackingState, RootStoreState> = {
  namespaced: true,
  actions: TRACKING_ACTIONS,
  mutations: TRACKING_MUTATIONS,
  state: getInitialTrackingState()
};
